import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const footer: PartialTranslation["footer"] = {
  tagline: "Nền tảng học ngôn ngữ của bạn",
  description:
    "Xây dựng sự tự tin khi nói tiếng Anh với các buổi luyện tập có AI, bài tập từ vựng và phản hồi theo thời gian thực. Học theo tốc độ của bạn.",
  sections: {
    learn: "Học tập",
    support: "Hỗ trợ",
    community: "Cộng đồng",
  },
  links: {
    browseTopics: "Khám phá chủ đề",
    browseTopicsDescription: "Khám phá các chủ đề luyện tập",
    vocabulary: "Từ vựng",
    vocabularyDescription: "Xây dựng kho từ của bạn",
    studyGroups: "Nhóm học",
    studyGroupsDescription: "Học cùng người khác",
    leaderboard: "Bảng xếp hạng",
    leaderboardDescription: "Theo dõi tiến độ của bạn",
    features: "Tính năng",
    faq: "Câu hỏi thường gặp",
    community: "Cộng đồng",
    privacy: "Chính sách bảo mật",
    terms: "Điều khoản sử dụng",
  },
  communityBlurb:
    "Tham gia cộng đồng người học ngôn ngữ của chúng tôi để nhận mẹo, động lực và sự hỗ trợ.",
  allRightsReserved: "© {{year}} Lyder Talk. Bảo lưu mọi quyền.",
  madeWith: "Được làm với",
  forLearners: "cho người học",
  };
